import { Component, Input } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wor-loan-car-review',
  template: `
    <div class="modal-header clearfix bg-info title">
      <div class="pull-left">
        <h1>
          <i class="fa fa-tag"></i>
          {{ 'LOAN_CAR_SPACE.REVIEW_LOAN_CAR' | translate }}
          <span *ngIf="loanCar?.invoice_id && !loanCar?.event_id">
            {{ 'LOAN_CAR_SPACE.FOR_JOB' | translate:{ job: invoice?.job_card_number } }}
          </span>
          <span *ngIf="!loanCar?.invoice_id && loanCar?.event_id">
            {{ 'LOAN_CAR_SPACE.FOR_BOOKING' | translate:{ num: event?.event_number } }}
          </span>
          <span *ngIf="loanCar?.invoice_id && loanCar?.event_id">
            {{ 'LOAN_CAR_SPACE.FOR_BOOKING_JOB' | translate:{ num: event?.event_number, job: invoice?.job_card_number } }}
          </span>
        </h1>
      </div>
    </div>
    <div class="modal-body clearfix">
      <div class="top-buffer info" *ngIf="loanCar?.id">
        <fieldset class="top-buffer">
          <div class="col-md-6">
            <label translate="CUSTOMER_SPACE.CUSTOMER_DETAILS"></label>
            <p>
              <span>{{ loanCar.contact_first_name }}</span>
              <span>{{ loanCar.contact_last_name }}</span>
            </p>
            <p>
              <span>{{ loanCar.contact_address1 }}</span><span>, {{ loanCar.contact_address2 }}</span><span>, {{ loanCar.contact_suburb }}</span><span>, {{ loanCar.contact_state }}</span><span>, {{ loanCar.contact_postcode }}</span>
            </p>
            <p>
              <span>{{ 'LOAN_CAR_SPACE.PHONE_SHORT' | translate }}: {{ loanCar.contact_phone }}</span>
              <span> {{ 'LOAN_CAR_SPACE.MOBILE_SHORT' | translate }}: {{ loanCar.contact_mobile }}</span>
              <span> {{ 'GENERAL_SPACE.FIELD.EMAIL' | translate }}: {{ loanCar.contact_email }}</span>
            </p>
          </div>
          <div class="col-md-6">
            <label translate="LOAN_CAR_SPACE.LOAN_VEHICLE_DETAILS"></label>
            <p><span>{{ loanVehicle?.plate_number }}</span></p>
            <p>
              <span>{{ loanVehicle?.make }}</span>
              <span> {{ loanVehicle?.model }}</span>
              <span> {{ loanVehicle?.model_code }}</span>
              <span> {{ loanVehicle?.model_series }}</span>
            </p>
            <p>
              <span>{{ loanVehicle?.build_date }}</span>
              <span> {{ loanVehicle?.colour }}</span>
            </p>
          </div>
        </fieldset>
        <fieldset class="top-buffer">
          <div class="col-md-6">
            <label translate="LOAN_CAR_SPACE.LICENSE_DETAILS"></label>
            <p><span>{{ 'LOAN_CAR_SPACE.LICENSE_NUMBER' | translate }}: {{ loanCar.license_number }}</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.LICENSE_EXPIRY' | translate }}: {{ loanCar.license_expiry | globalDate }}</span></p>
          </div>
          <div class="col-md-6">
            <label translate="LOAN_CAR_SPACE.LOAN_BOOKING_DETAILS"></label>
            <p><span>{{ 'LOAN_CAR_SPACE.BOOKING_START' | translate }}: {{ loanCar.local_booking_start_time | dateTime }}</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.BOOKING_END' | translate }}: {{ loanCar.local_booking_end_time | dateTime }}</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.LOAN_START' | translate }}: {{ loanCar.local_start_time | dateTime }}</span></p>
            <p *ngIf="loanCar.local_return_time">
              <span>{{ 'LOAN_CAR_SPACE.LOAN_RETURN' | translate }}: {{ loanCar.local_return_time | dateTime }}</span>
            </p>
          </div>
        </fieldset>
        <fieldset class="top-buffer">
          <div class="col-md-6">
            <label translate="LOAN_CAR_SPACE.PRE_LOAN_CHECK_DETAILS"></label>
            <p><span>{{ 'VEHICLE_SPACE.ODOMETER' | translate }}: {{ loanCar.odometer_before }}</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.FUEL_LEVEL' | translate }}: {{ loanCar.fuel_level_before }}%</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.CLEAN' | translate }}: {{ loanCar.loan_vehicle_clean_before }}</span></p>
          </div>
          <div class="col-md-6">
            <p><span>{{ 'GENERAL_SPACE.FIELD.NOTES' | translate }}: {{ loanCar.note_before }}</span></p>
            <p><span>{{ 'INSPECTIONS_SPACE.SERVICE_ADVISERS.SERVICE_ADVISER' | translate }}: {{ serviceAdviserBefore?.display_name }}</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.TERMS_AGREED_TO_BY_CUSTOMER' | translate }}: {{ loanCar.terms_agreed_to_by_customer }}</span></p>
          </div>
        </fieldset>
        <fieldset class="top-buffer">
          <div class="col-md-6">
            <label translate="LOAN_CAR_SPACE.POST_LOAN_CHECK_DETAILS"></label>
            <p><span>{{ 'VEHICLE_SPACE.ODOMETER' | translate }}: {{ loanCar.odometer_return }}</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.FUEL_LEVEL' | translate }}: {{ loanCar.fuel_level_return }}%</span></p>
            <p><span>{{ 'LOAN_CAR_SPACE.CLEAN' | translate }}: {{ loanCar.loan_vehicle_clean_return }}</span></p>
          </div>
          <div class="col-md-6">
            <p><span>{{ 'GENERAL_SPACE.FIELD.NOTES' | translate }}: {{ loanCar.note_return }}</span></p>
            <p><span>{{ 'INSPECTIONS_SPACE.SERVICE_ADVISERS.SERVICE_ADVISER' | translate }}: {{ serviceAdviserReturn?.display_name }}</span></p>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default pull-left"
        (click)="modal.dismiss()"
        translate="GENERAL_SPACE.BUTTON.DONE">
      </button>
    </div>
  `
})
export class LoanCarReviewComponent {
  @Input() loanCar            : any;
  @Input() loanVehicle        : any;
  @Input() invoice            : any;
  @Input() event              : any;
  @Input() serviceAdviserBefore: any;
  @Input() serviceAdviserReturn: any;

  constructor (
    public modal: NgbActiveModal
  ) {}
}
